import Drawer from "../../../../components/elements/Drawer";
import SubscriptionDetails from "./SubscriptionDetails";

const SubscriptionDetailsDrawer = ({ open, close = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl5"}
      title={"Subscription Details"}
      subtitle=""
      drawerBodyClass="p-2 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <SubscriptionDetails close={close} item={data} />
      </div>
    </Drawer>
  );
};

export default SubscriptionDetailsDrawer;
